import { defineComponent, ref, createElementBlock, openBlock, createElementVNode, createVNode, withCtx, renderSlot } from 'vue';
import _sfc_main$1 from './basler-components.es75.js';
/* empty css                       */
import _sfc_main$2 from './basler-components.es70.js';

const _hoisted_1 = { class: "form-single-field" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "FormSingleField",
  props: {
    modelValue: { default: "" },
    inputId: {},
    inputType: { default: "search" },
    inputIsRequired: { type: Boolean, default: false },
    iconName: { default: "magnifier" },
    submitButtonLabel: { default: "Submit" }
  },
  emits: ["submit:modelValue"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const inputValue = ref(props.modelValue);
    const update = (event) => {
      event.preventDefault();
      emit("submit:modelValue", inputValue.value);
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("form", { onSubmit: update }, [
        createElementVNode("div", _hoisted_1, [
          createVNode(_sfc_main$1, {
            modelValue: inputValue.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => inputValue.value = $event),
            id: _ctx.inputId,
            type: _ctx.inputType,
            "label-first": false,
            "label-inside": true,
            "is-required": _ctx.inputIsRequired
          }, {
            default: withCtx(() => [
              renderSlot(_ctx.$slots, "default")
            ]),
            _: 3
          }, 8, ["modelValue", "id", "type", "is-required"]),
          createVNode(_sfc_main$2, {
            type: "submit",
            "icon-name": _ctx.iconName,
            "icon-type": "icon-only",
            "style-type": "none",
            "aria-label": _ctx.submitButtonLabel
          }, null, 8, ["icon-name", "aria-label"])
        ])
      ], 32);
    };
  }
});

export { _sfc_main as default };
